export enum DiscountType {
    Individual = 1,
    Family = 2,
  }